import { Box, Chip, Grid, IconButton, Paper, Typography } from '@mui/material';
import InputConfig from '../../../../Components/InputConfig';
import { useContext, useMemo } from 'react';
import { FvpConfigContext } from '../../../../Contexts/FvpConfigContext';
import { ACCESS_CONTROL_CONSTANTS, FVP_CONFIG_EDIT_MODES } from '../../../../core/constants';
import { ContentCopy } from '@mui/icons-material';
import { copyToClipboard } from '../../../../utilities/helpers';
import useStyles from './styles';
import { getFvpNetworkCode } from './helper';
import useCommonStyles from '../../../../commonStyles';
import PageHeading from '../../../../Components/PageHeading';

const { SYSTEMS } = ACCESS_CONTROL_CONSTANTS;

/**
 * @name FvpGeneralSetting
 * @description This component is an editor used to manage  top level configuration at the site level.
 *
 *
 * @Config {    siteId: '',  siteDomain: ''}
 *
 * */

const FvpGeneralSetting = () => {
	const { fvpConfigEditMode, fvpConfig, updateFvpConfig } = useContext(FvpConfigContext);
	const fallbackXmlConfig = fvpConfig?.fallbackXmlConfig;
	const { siteId, siteDomain, mcmId } = fvpConfig;
	const isFvpConfigValid = siteId && siteDomain && mcmId;
	const commonStyleClasses = useCommonStyles();
	const fallbackChip = useMemo(() => {
		if (
			fallbackXmlConfig &&
			fallbackXmlConfig.enabled &&
			Array.isArray(fallbackXmlConfig.vastTagUrls) &&
			fallbackXmlConfig.vastTagUrls.length > 0
		) {
			return <Chip color="success" label="Fallback" />;
		} else {
			return <Chip color="info" label="Fvp" />;
		}
	}, [fvpConfig]);

	if (fvpConfig == null) return;

	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Site"
				headingPath={['Dashboard', 'Fvp', 'Site']}
				description="Manage all default site level settings like siteId, siteDomain etc."
			/>
			<Grid
				container
				spacing={2}
				style={{
					width: '95%',
					marginLeft: '3rem',
					marginTop: '3rem'
				}}
			>
				<Grid item sm={12} style={{ marginBottom: '2.5%' }}>
					{fallbackChip}
				</Grid>
				<Grid item sm={3}>
					<InputConfig
						system={SYSTEMS.FVP_PLAYER}
						label="Site Id"
						keyData="siteId"
						inputType="number"
						object={fvpConfig}
						updateObject={updateFvpConfig}
						editable={fvpConfigEditMode === FVP_CONFIG_EDIT_MODES.CREATE}
					/>
				</Grid>
				<Grid item sm={3}>
					<InputConfig
						system={SYSTEMS.FVP_PLAYER}
						label="Site Domain"
						keyData="siteDomain"
						object={fvpConfig}
						updateObject={updateFvpConfig}
						editable={fvpConfigEditMode === FVP_CONFIG_EDIT_MODES.CREATE}
					/>
				</Grid>
				<Grid item sm={3}>
					<InputConfig
						system={SYSTEMS.FVP_PLAYER}
						label="MCM Id"
						keyData="mcmId"
						object={fvpConfig}
						updateObject={updateFvpConfig}
						editable={fvpConfigEditMode === FVP_CONFIG_EDIT_MODES.CREATE}
					/>
				</Grid>

				<Grid item sm={12}>
					{isFvpConfigValid ? (
						<>
							<Typography
								variant="h5"
								fontWeight={600}
								style={{
									display: 'flex',
									justifyContent: 'center',
									color: 'red'
								}}
							>
								Vpaid Ad tag
							</Typography>
							<NetworkCode
								networkCode={getFvpNetworkCode(siteId, siteDomain, mcmId)}
								successMessage={'Successfully Copied'}
							/>
						</>
					) : (
						<Typography
							variant="h7"
							fontWeight={400}
							className="warning-text"
							style={{
								display: 'flex',
								justifyContent: 'center',
								color: 'red',
								marginTop: '2rem'
							}}
						>
							Enter all details to get vpaid adtag
						</Typography>
					)}
				</Grid>
			</Grid>
		</Paper>
	);
};

const NetworkCode = ({ networkCode, successMessage }) => {
	const classes = useStyles();

	return (
		<Box className={classes.output}>
			<IconButton
				style={{ position: 'absolute', top: '1rem', right: '1rem' }}
				onClick={() => copyToClipboard(networkCode, successMessage)}
			>
				<ContentCopy />
			</IconButton>

			<Typography
				style={{
					marginTop: '3rem'
				}}
			>
				{networkCode}
			</Typography>
		</Box>
	);
};

export default FvpGeneralSetting;
